import { z } from 'zod';

const PixelEventBaseSchema = z.object({
  type: z.string(),
  cat: z.string(),
  user: z.object({
    uid: z.string().nullable(),
    role: z.object({
      type: z.string(),
      id: z.string().nullable()
    }).nullable()
  }).nullable(),
  sid: z.string().nullable()
});

export { PixelEventBaseSchema };
